/* ------------------------------------------------------------------------ */
/*		File: cmpHeadquartes.tsx                                            */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React, { useEffect } from "react";
import { ICmpHeadquarters, Coordinates } from "./cmpHeadquarters.d";
import "./cmpHeadquarters.css";

/* ------------------------------------------------------------------------ */


const loadGoogleMapsScript = () => {
    return new Promise<void>((resolve, reject) => {
        if (window.google && window.google.maps) {
            resolve();
            return;
        }

        const existingScript = document.querySelector(`script[src*="maps.googleapis.com/maps/api/js"]`);
        if (existingScript) {
            existingScript.addEventListener('load', () => resolve());
            existingScript.addEventListener('error', () => reject(new Error("Error loading Google Maps script")));
            return;
        }

        const script = document.createElement('script');
        const API_KEY = "AIzaSyAultx_AIlOwrmUN7O6URJXL4gKRF-bte0";
        script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=initMap`;
        script.async = true;
        script.defer = true;

        script.onload = () => resolve();
        script.onerror = () => reject(new Error("Error loading Google Maps script"));
        document.head.appendChild(script);
    });
};

/* ------------------------------------------------------------------------ */

declare global {
    interface Window {
        google: any;
        initMap: () => void;
    }
}

/* ------------------------------------------------------------------------ */

const GoogleMap: React.FC<{ coords: Coordinates, id: string }> = ({ coords, id }) => {
    useEffect(() => {
        const initMap = () => {
            const map = new window.google.maps.Map(document.getElementById(id) as HTMLElement, {
                center: coords,
                zoom: 14,
            });

            if (window.google.maps.marker && window.google.maps.marker.AdvancedMarkerElement) {
                new window.google.maps.marker.AdvancedMarkerElement({
                    position: coords,
                    map: map,
                    title: "Location Marker",
                });
            } else {
                console.warn("AdvancedMarkerElement is not available, falling back to Marker.");
                new window.google.maps.Marker({
                    position: coords,
                    map: map,
                    title: "Location Marker",
                });
            }
        };

        window.initMap = initMap;

        loadGoogleMapsScript()
            .then(() => {
                if (window.google && window.google.maps) {
                    initMap();
                }
            })
            .catch(err => {
                console.error("Failed to load Google Maps script:", err);
            });

    }, [coords, id]);

    return <div id={id} style={{ width: "100%", height: "100%" }}></div>;
};

/* ------------------------------------------------------------------------ */

const Headquarters: React.FC<ICmpHeadquarters> = (props) => {
    props.options?.sort((a, b) => { return (a.position! < b.position! ?  -1 : 0)})

    const getImage = (img: any) => {
        try {
            return require(`../../img/${img}`);
        } catch (err) {
            console.error("Error loading image:", img, err);
            return ""; 
        }
    }

    return (
        <div className="card_headquarters">
            {props.options?.map((item, index) => {
                return (
                    <div 
                        key={`card_headquarters-${index}`} 
                        className="card_headquarters_container"
                    >
                        <div className="card_headquarters_location">
                            <img src={getImage(item.src)} alt={item.src}/>
                            <div className="card_headquarters_location_label">{item.label}</div>
                        </div>

                        <div className="card_headquarters_description">{item.description}</div>
                        <div className="card_headquarters_map">
                            {item.map && <GoogleMap coords={item.map} id={`map-${index}`} />}
                        </div>
                    </div>
                )
            })}
            <div className="card_headquarters_bigmap">
                <img src={getImage(props.src)} alt={props.src}/>
            </div>
        </div>
    );
  };
  export default Headquarters;

